import { ReactNode } from "react";
import LeafRectangleLoader from "../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";

export const KeyInformationBlockLoader = ({ numRows = 3 }: { numRows?: number }) => {
  return (
    <div className="keyInformationBlock">
      <div>
        <LeafRectangleLoader isLoading width="40%" height="1rem" />
      </div>
      <div>
        <LeafRectangleLoader isLoading numRows={numRows} width="100%" height="1.25rem" margin="0.5rem 0" />
      </div>
    </div>
  );
};

interface KeyInformationBlockProps {
  header: string;
  className?: string;
  children?: ReactNode;
  isLoading?: boolean;
}
const KeyInformationBlock = ({ header, className, children, isLoading }: KeyInformationBlockProps) => {
  if (isLoading) return <KeyInformationBlockLoader />;
  return (
    <>
      <div className={`keyInformationBlock ${className ?? ""}`}>
        <div>
          <p>{header}</p>
        </div>
        <div>{children}</div>
      </div>
    </>
  );
};

export default KeyInformationBlock;
